import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/toast';
import ProtectedRoute from './components/ProtectedRoute';
import NavigationBar from './components/Navbar';
import Login from './components/Login';
import BusRecordForm from './components/BusRecordForm';
import BusRecordList from './components/BusRecordList';
import Statistics from './components/Statistics';
import BusStopMapPage from './components/BusStopMapPage';
import MapTest from './components/MapTest';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const AppContent = () => {
  const { user } = useAuth();

  return (
    <Router>
      <div className="App">
        {user && <NavigationBar />}
        <main className="main-content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <BusRecordForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/records"
              element={
                <ProtectedRoute>
                  <BusRecordList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stats"
              element={
                <ProtectedRoute>
                  <Statistics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/map"
              element={
                <ProtectedRoute>
                  <BusStopMapPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/test"
              element={
                <ProtectedRoute>
                  <MapTest />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <AppContent />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
